module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Taegerig_AG-b7cf18cbf7366b4e1c0100dfb7bd8d7b.svg";